// Escalating display for the reigning champion's title-defense streak (from the
// global streak.txt). The visual ramps with `level` (1–5) — emoji + a flavor word
// here, with the size/glow/animation done in CSS (ChampStreakBadge.vue). Returns
// null below 1 so the badge just doesn't render.

const TIERS = [
  { min: 12, level: 5, emoji: '👑🔥🔥🔥👑', word: 'LEGENDARY' },
  { min: 8,  level: 4, emoji: '🔥🔥🔥',      word: 'UNSTOPPABLE' },
  { min: 5,  level: 3, emoji: '🔥🔥🔥',      word: 'dominating' },
  { min: 3,  level: 2, emoji: '🔥🔥',        word: 'on a tear' },
  { min: 1,  level: 1, emoji: '🔥',          word: '' },
];

export function streakDisplay(streak) {
  const n = Math.max(0, Math.floor(Number(streak) || 0));
  if (n < 1) return null;
  const t = TIERS.find((x) => n >= x.min);
  return { n, level: t.level, emoji: t.emoji, word: t.word };
}
